import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import LoginView from './components/LoginView';
import ForgotPasswordView from './components/ForgotPasswordView';
import RegisterContainer from './containers/RegisterContainer';
import ResetPassword from './components/ResetPassword';
import ConfirmEmail from './components/ConfirmEmail';
import AUTH_PATHS from '@Routing/paths/auth.json';

const AuthRoutes: React.FC = () => {
	return (
		<Switch>
			<Route path={AUTH_PATHS.LOGIN} component={LoginView} />
			<Route path={AUTH_PATHS.FORGOT_PASSWORD} component={ForgotPasswordView} />
			<Route path={AUTH_PATHS.RESET_PASSWORD} component={ResetPassword} />
			<Route exact path={AUTH_PATHS.REGISTER} component={RegisterContainer} />
			<Route exact path={AUTH_PATHS.CONFIRM_EMAIL} component={ConfirmEmail} />

			<Redirect from={AUTH_PATHS.ROOT} exact={true} to={AUTH_PATHS.LOGIN} />
			<Redirect to={AUTH_PATHS.LOGIN} />
		</Switch>
	);
};

export default AuthRoutes;
